import {
  getAllConfig,
  getConfig,
  setConfig,
  setCode,
  getList,
  delConfig,
  closeConfig,
  openConfig,
  getTvGroupList,
  getMergeConfig,
  setMergeConfig,
  getTvSelect,
  getAllUselList
} from '@/services/configTv'
import i18n from '@/lib/language'

export default {
  namespaced: true,
  state: {
    columns: [{
      title: i18n.t('message[1787]'), // '屏幕'
      dataIndex: 'name',
      key: 'name',
      slots: { title: 'name' },
      scopedSlots: { customRender: 'name' },
      width: 417
    }, {
      title: i18n.t('message[1788]'), // '布局'
      dataIndex: 'type',
      key: 'type',
      slots: { title: 'type' },
      scopedSlots: { customRender: 'type' },
      width: 350
    }, {
      title: i18n.t('message[79]'), // '操作'
      dataIndex: 'action',
      slots: { title: 'action' },
      scopedSlots: { customRender: 'action' },
      width: 273
    }],
    listDatas: [],
    groupColumns: [{
      title: i18n.t('message[1926]'), // '组合'
      dataIndex: 'name',
      key: 'name',
      slots: { title: 'name' },
      scopedSlots: { customRender: 'name' },
      width: 367
    }, {
      title: i18n.t('message[79]'), // '操作'
      dataIndex: 'action',
      slots: { title: 'action' },
      scopedSlots: { customRender: 'action' },
      width: 273
    }],
    groupListDatas: [],
    loading: null,
    allConfig: null,
    layoutTypeOptions: [{
      id: 8,
      name: i18n.t('message[1959]')// '单个团队'
    }, {
      id: 9,
      name: i18n.t('message[1960]') // '两个团队'
    }, {
      id: 10,
      name: i18n.t('message[1961]') // '三个团队'
    }],
    rangeTypeOptions: [{
      key: 'dev',
      name: i18n.t('message[1804]') // '信息开发'
    }, {
      key: 'rec',
      name: i18n.t('message[1805]') // '信息接待'
    }, {
      key: 'follow',
      name: i18n.t('message[1806]') // '销售'
    }],
    formData: {
      type: undefined,
      name: '',
      range: [],
      target: []
    },
    groupDetail: {
      name: '',
      data: [],
      playtime: 1
    },
    tvSelectOptions: [],
    allUselList: []
  },

  mutations: {
    setListDatas (state, data) {
      state.listDatas = data
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    setAllConfig (state, data) {
      state.allConfig = data
    },
    SET_DETAIL (state, data = {}) {
      state.formData = data
    },
    setGroupListDatas (state, data) {
      state.groupListDatas = data
    },
    setGroupDetail (state, res = {}) {
      const { id, name, data = [], playtime } = res
      state.groupDetail = { id, name, data, playtime }
    },
    setTvSelectOptions (state, data = {}) {
      state.tvSelectOptions = data
    },
    setAllUselList (state, data = {}) {
      state.allUselList = data
    }
  },
  actions: {
    async fetchTvList ({ commit }, params) {
      commit('SET_LOADING', true)
      commit('setListDatas', [])
      let chain = await getList()
      chain
        .params(params)
        .onSuccess((raw = {}) => {
          commit('setListDatas', raw.list || [])
          commit('SET_LOADING', false)
        })
        .fetch()
      return chain
    },
    async getTvGroupList ({ commit }, params) {
      commit('SET_LOADING', true)
      // commit('setGroupListDatas', [])
      let chain = await getTvGroupList()
      chain
        .params(params)
        .onSuccess((raw = {}) => {
          commit('setGroupListDatas', raw.list || [])
          commit('SET_LOADING', false)
        })
        .fetch()
      return chain
    },
    async fetchDetail ({ commit }, params) {
      commit('SET_DETAIL', {})
      let chain = await getConfig()
      chain
        .params(params)
        .onSuccess((raw = {}) => {
          commit('SET_DETAIL', raw)
        })
        .fetch()
      return chain
    },
    async fetchAllConfig ({ commit }, params) {
      let chain = await getAllConfig()
      chain
        .params(params)
        .onSuccess((raw = {}) => {
          commit('setAllConfig', raw)
        })
        .fetch()
      return chain
    },

    async setConfig ({ commit, dispatch }, params) {
      let chain = await setConfig()
      chain
        .params(params)
        .onSuccess(res => {

        })
        .fetch()
      return chain
    },
    async fetchCode ({ commit }, params) {
      let chain = await setCode()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async delConfig ({ commit }, params) {
      let chain = await delConfig()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async closeConfig ({ commit }, params) {
      let chain = await closeConfig()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async openConfig ({ commit }, params) {
      let chain = await openConfig()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async getMergeConfig ({ commit }, params) {
      let chain = await getMergeConfig()
      chain
        .params(params)
        .onSuccess((raw = {}) => {
          commit('setGroupDetail', raw)
        })
        .fetch()
      return chain
    },
    async setMergeConfig ({ commit }, params) {
      let chain = await setMergeConfig()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async getTvSelect ({ commit }, params) {
      let chain = await getTvSelect()
      chain
        .params(params)
        .onSuccess((raw = {}) => {
          commit('setTvSelectOptions', raw)
        })
        .fetch()
      return chain
    },
    async getAllUselList ({ commit }, params) {
      let chain = await getAllUselList()
      chain
        .params(params)
        .onSuccess((raw = {}) => {
          commit('setAllUselList', raw)
        })
        .fetch()
      return chain
    }
  }
}
